export default [
    {
        "id": "widget-1",
        "plugin": null,
        "pluginId": null,
        "name": "widgetPosition",
        "relatedBanner": "widgetBanner",
        "html": require("./widgets/widget-1/html").default,
		"showOptions": false,
        "showAllArrows": true,
		"fixedView": true,
		"config": `{"widgetPosition" : "rightBottom"}`,
        "css": require("./widgets/widget-1/css").default,
        "scss": require("./widgets/widget-1/scss").default,
        "js": require("./widgets/widget-1/js").default,
        "minJs": require("./widgets/widget-1/minJs").default,
		"cssMobile": require("./widgets/widget-1/cssMobile").default,
		"scssMobile": require("./widgets/widget-1/scssMobile").default,
        "svgContent": require("./widgets/widget-1/svgContent").default,
		"svgViewBox": `0 0 496 168`,
        "folder": "widgets"
    }
]